import React, { useEffect, useState } from 'react';
import client from '../../common/api';

// this is public billing HOC, only for public pages
const WithBillingDetails = (WrappedComponent) => {
    const BillingWrap = (props) => {
        const [billingDetails, setBillingDetails] = useState(null);
        const [loading, setLoading] = useState(true);
        const activeSpace = window.location.host.split('.')[0];

        useEffect(() => {
            const hostUrl = window.location.host;
            const _hostUrl = hostUrl.replace("www.", "");
            client.get('/api/public/billing', { params: { activeSpaceName: activeSpace, url: _hostUrl } }).then(response => {
                const billingResp = response.data;
                if (billingResp.success) {
                    setBillingDetails(response.data.data);
                    setLoading(false);
                }
            })
                .catch(error => {
                    console.error('Billing details fetch error:', error);
                    // setError(error);
                    setLoading(false);
                });
        }, []);

        return (
            <WrappedComponent
                {...props}
                billingDetails={billingDetails}
                billingLoading={loading}
            />
        );
    };
    return BillingWrap;
};

export default WithBillingDetails;